import { HttpContext, HttpContextToken } from '@angular/common/http';

export const AUTOSAVE_CONTEXT = new HttpContextToken<string>(() => '');

export function getAutosaveContext(key: string): HttpContext {
  return new HttpContext().set(AUTOSAVE_CONTEXT, key);
}